/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

//==============================================================
// START Enums and Input Objects
//==============================================================

export enum AdministrativeGender {
  female = "female",
  male = "male",
}

export enum PapiPaymentStatus {
  DRAFT = "DRAFT",
  IN_ARREARS = "IN_ARREARS",
  OPEN = "OPEN",
  PAID = "PAID",
  PENDING = "PENDING",
  UNCOLLECTIBLE = "UNCOLLECTIBLE",
  UNKNOWN = "UNKNOWN",
  VOID = "VOID",
}

export enum PapiProductType {
  ASSESSMENT = "ASSESSMENT",
  BASIC_HORMONE_ANALYSIS = "BASIC_HORMONE_ANALYSIS",
  COMPLETE_CARE_RENEWAL = "COMPLETE_CARE_RENEWAL",
  COMPLETE_CARE_Y1 = "COMPLETE_CARE_Y1",
  COMPLETE_CARE_Y1_POST_ASSESSMENT = "COMPLETE_CARE_Y1_POST_ASSESSMENT",
  COMPLETE_CARE_Y2_PLUS = "COMPLETE_CARE_Y2_PLUS",
  COMPREHENSIVE_GUT_ANALYSIS = "COMPREHENSIVE_GUT_ANALYSIS",
  COMPREHENSIVE_GUT_MEMBERSHIP = "COMPREHENSIVE_GUT_MEMBERSHIP",
  COMPREHENSIVE_HORMONE_ANALYSIS = "COMPREHENSIVE_HORMONE_ANALYSIS",
  COMPREHENSIVE_HORMONE_MEMBERSHIP = "COMPREHENSIVE_HORMONE_MEMBERSHIP",
  COMPREHENSIVE_HORMONE_PLAN = "COMPREHENSIVE_HORMONE_PLAN",
  ESSENTIAL_CARE = "ESSENTIAL_CARE",
  EXTENSION = "EXTENSION",
  FOLLOW_UP_ASSESSMENT = "FOLLOW_UP_ASSESSMENT",
  FOUNDING_MEMBERSHIP = "FOUNDING_MEMBERSHIP",
  FREE_TRIAL = "FREE_TRIAL",
  HEALTH_RISK_ASSESSMENT = "HEALTH_RISK_ASSESSMENT",
  HORMONE_MEMBERSHIP = "HORMONE_MEMBERSHIP",
  MENOPAUSE_LIFECYCLE_HORMONE_ANALYSIS = "MENOPAUSE_LIFECYCLE_HORMONE_ANALYSIS",
  MENOPAUSE_LIFECYCLE_HORMONE_MEMBERSHIP = "MENOPAUSE_LIFECYCLE_HORMONE_MEMBERSHIP",
  MERIWETHER = "MERIWETHER",
  NO_PRODUCT = "NO_PRODUCT",
  PEDIATRICS = "PEDIATRICS",
  PEDIATRICS_RENEWAL = "PEDIATRICS_RENEWAL",
  SHORT_PROGRAM = "SHORT_PROGRAM",
  VIRTUAL_ASSESSMENT = "VIRTUAL_ASSESSMENT",
  VIRTUAL_COMPLETE_CARE_Y1 = "VIRTUAL_COMPLETE_CARE_Y1",
  VIRTUAL_COMPLETE_CARE_Y2_PLUS = "VIRTUAL_COMPLETE_CARE_Y2_PLUS",
  WAITLIST_ASSESSMENT = "WAITLIST_ASSESSMENT",
  WAITLIST_COMPLETE_CARE = "WAITLIST_COMPLETE_CARE",
  WAITLIST_PEDIATRICS = "WAITLIST_PEDIATRICS",
  WAITLIST_SHORT_PROGRAM = "WAITLIST_SHORT_PROGRAM",
  WAITLIST_VIRTUAL_ASSESSMENT = "WAITLIST_VIRTUAL_ASSESSMENT",
  WAITLIST_VIRTUAL_COMPLETE_CARE = "WAITLIST_VIRTUAL_COMPLETE_CARE",
}

export enum PapiSex {
  FEMALE = "FEMALE",
  MALE = "MALE",
  OTHER = "OTHER",
}

export interface AddressInput {
  addressLine1: string;
  addressLine2?: string | null;
  city: string;
  state: string;
  zipCode: string;
}

export interface CreateImawarePatientInput {
  id: string;
  biologicalSex: AdministrativeGender;
  address: AddressInput;
  phoneNumber: string;
}

export interface PapiCreateInsightsUserInput {
  email: string;
  firstName: string;
  lastName: string;
  dateOfBirth: string;
  biologicalSex?: PapiSex | null;
  centerID: string;
  sendPasswordReset: boolean;
}

export interface PapiRecaptchaInput {
  token: string;
  ipAddress: string;
}

//==============================================================
// END Enums and Input Objects
//==============================================================
